import type { z } from 'zod';
import type { GetAppResultSchema } from '@greenlight/shared';

type GetAppResult = z.infer<typeof GetAppResultSchema>;

/** Resolve the live app URL from the getApp payload (prefers backend-built URL). */
export function resolveDeployUrl(detail: GetAppResult): string | null {
  return (
    detail.shared_environment.deployment_url ??
    (detail.shared_environment.domain ? `https://${detail.shared_environment.domain}` : null)
  );
}
